<template>
  <div class="fade-in-fwd">
    <div class="mt-5" :class="isMobile?'custom-container':'container'">
      <h6 class="font-weight-bold">
        {{ $resourceString["myProject.Project.AddItemModal.Title"] }}
      </h6>
      <button
        type="button"
        class="wf-modal-button-close btn button-full"
        @click="closeModal()"
      >
        <span
          class="png-icon png-icon-icons-symbols--k-txtclose"
          aria-label="Close modal"
        />
      </button>

      <div v-if="getContentWizardData.step !== 1">
        <div class="my-project stepper-container row">
          <ul class="stepper d-flex justify-content-center ml-3 mr-3">
            <li
              v-for="[stepIndex, header] in Object.entries(stepHeaders)"
              :key="header"
              :class="getClassName(stepIndex)"
            >
              {{ $resourceString[header] }}
            </li>

            <li
              v-if="getContentWizardData.isOutOfProject"
              :class="(getLastStep && getContentWizardData.isOutOfProject) ? 'active' : ''"
            >
              {{ $resourceString['contentWizard.Label.ChooseProject'] }}
            </li>

          </ul>
        </div>
      </div>

      <div v-if="getContentWizardData.step === 1">
        <step-one />
      </div>

      <div v-if="getContentWizardData.contentItem.type == CustomContentItemTypes.webPage && getContentWizardData.step == 2 ">
        <stepWebPage/>
      </div>

      <div v-if="getLastStep && getContentWizardData.isOutOfProject">
        <choose-project/>
      </div>

      <div v-if="getContentWizardData.contentItem.type == CustomContentItemTypes.product && getContentWizardData.step == 2 ">
        <step-two/>
      </div>
      <div v-if="getContentWizardData.contentItem.type == CustomContentItemTypes.product && getContentWizardData.step == 3 ">
        <step-three/>
      </div>
      <div v-if="getContentWizardData.contentItem.type == CustomContentItemTypes.product && getContentWizardData.step == 4 ">
        <step-four/>
      </div>
      <div v-if="getContentWizardData.contentItem.type == CustomContentItemTypes.virtualTray && getContentWizardData.step == 2 ">
        <vtStep/>
      </div>
      <div v-if="getContentWizardData.contentItem.type == CustomContentItemTypes.virtualTray && getContentWizardData.step == 3 ">
        <project-Editcontent-Item/>
      </div>
      <div v-if="getContentWizardData.contentItem.type == CustomContentItemTypes.customPattern && getContentWizardData.step == 2 ">
        <step-two/>
      </div>
      <div
        v-if="
          getContentWizardData.contentItem.type ==
            CustomContentItemTypes.customPattern &&
            getContentWizardData.step == 4
        "
      >
        <step-four />
      </div>
      <div
        v-if="
          getContentWizardData.contentItem.type ==
            CustomContentItemTypes.galleryImages &&
            getContentWizardData.step == 2
        "
      >
        <gallery-Images-Step-Two />
      </div>
      <div
        v-if="
          getContentWizardData.contentItem.type ==
            CustomContentItemTypes.galleryImages &&
            getContentWizardData.step == 3
        "
      >
        <gallery-Images-Step-Three />
      </div>
      <div
        v-if="
          getContentWizardData.contentItem.type ==
            CustomContentItemTypes.addDocument && getContentWizardData.step == 2
        "
      >
        <add-document-Step-Two />
      </div>
      <div
        v-if="
          getContentWizardData.contentItem.type ==
            CustomContentItemTypes.addDocument && getContentWizardData.step == 3
        "
      >
        <add-document-Step-Three />
      </div>
    </div>

    <!-- Modal Footer section -->
    <div class="modal-footer border-0 pl-gutter pr-gutter">
      <div class="justify-content-between w-100 row">
        <button
          class="btn btn-outline-primary"
          @click="closeModal()"
        >
          {{ $resourceString["virtualtray.Savetray.Cancel.Button"] }}
        </button>
        <span>
          <button
            v-if="getContentWizardData.step !== 1"
            class="btn btn-outline-primary mx-2"
            @click="handleBack"
          >
            {{ $resourceString["common.Button.Back"] }}
          </button>
          <button
            v-if="(getContentWizardData.step !== 1 && !getLastStep)"
            class="btn btn-primary"
            :disabled="getDisabled()"
            @click.prevent="handleNext"
          >
            {{ $resourceString["common.button.next"] }}
          </button>
          <button
            v-if="getLastStep"
            class="btn btn-primary"
            :disabled="getDisabled()"
            @click.prevent="addProjectItem"
          >
            {{
              $resourceString[
                "myProject.Project.AddItemModal.Button.AddToProject"
              ]
            }}
          </button>
        </span>
      </div>
    </div>
    <!-- end footer -->
  </div>
</template>
<script>
import {
  getStepHeaders,
  getStepComponent,
  ContentItemTypes,
  isLastStep
} from "../../../../src/stepTree";
import { mapActions, mapGetters } from "vuex";
import stepOne from "./steps/stepOne.vue";
import stepTwo from "./steps/stepTwo.vue";
import stepThree from "./steps/stepThree.vue";
import stepFour from "./steps/StepFour.vue";
import vtStep from "./steps/vtStep/vtStep.vue";
import stepWebPage from "./steps/web-page/index.vue";
import projectEditcontentItem from "./steps/vtStep/vtStepThree.vue";
import galleryImagesStepTwo from "./steps/galleryImagesStep/galleryImagesStepTwo.vue";
import galleryImagesStepThree from "./steps/galleryImagesStep/galleryImagesStepThree.vue";
import addDocumentStepTwo from "./steps/add-documents/add-document-stepTwo.vue";
import addDocumentStepThree from "./steps/add-documents/add-document-StepThree.vue";
import chooseProject from "./steps/choose-project/index.vue";

export default {
  props: ["projectDetails", "projectId", "isMobile"],
  data() {
    return {
      disableSubmitButton: false,
      CustomContentItemTypes:ContentItemTypes,
      myProjectDetails: this.projectDetails
    };
  },
  computed: {
    ...mapGetters({
      getContentWizardData: "contentWizard/getContentWizardData",
      getselectedTrayId: "contentWizard/getselectedTrayId",
      getSelectedProduct: "contentWizard/getSelectedProduct",
      getSelectedDocument: "contentWizard/getSelectedDocument",
      getisProductSearchDisabled: "contentWizard/getisProductSearchDisabled",
      getProjectDetails : "contentWizard/getProjectDetails"
    }),
    stepHeaders() {
      return getStepHeaders(
        this.getContentWizardData.contentItem.type,
        (this.myProjectDetails != null) ? 0 : 1
      );
    },
    getLastStep() {
      return isLastStep(
        this.getContentWizardData.contentItem.type,
        this.getContentWizardData.step,
        this.getContentWizardData.isOutOfProject,
        this.getContentWizardData.contentItem?.itemBoardId
      );
    },
    getItemType() {
      if (
        this.getContentWizardData.contentItem?.type ==
        this.CustomContentItemTypes.virtualTray
      ) {
        return 9;
      } else if (
        this.getContentWizardData.contentItem?.type ==
        this.CustomContentItemTypes.galleryImages
      ) {
        return 10;
      } else if (
        this.getContentWizardData.contentItem?.type ==
        this.CustomContentItemTypes.addDocument
      ) {
        return 3;
      } else {
        return 0;
      }
    }
  },
  components: {
    stepOne,
    vtStep,
    stepTwo,
    stepThree,
    stepFour,
    projectEditcontentItem,
    galleryImagesStepTwo,
    galleryImagesStepThree,
    addDocumentStepTwo,
    addDocumentStepThree,
    stepWebPage,
    chooseProject,
  },
  beforeDestroy(){
    const pdpMenuBar = document.getElementById('pdp-menu-bar') ;
    const productRoomSceneColors = document.getElementById('product-room-scene-colors');
    if (pdpMenuBar) {
        pdpMenuBar.style.zIndex = 2;
    }

    if (productRoomSceneColors) {
        productRoomSceneColors.style.zIndex = null;
    }
  },
  methods: {
    ...mapActions({
      setStep: "contentWizard/setStep",
      setStep1: "contentWizard/setStep1",
      createProductItem: "myProject/createProductItem",
      createDocumentItem: "contentWizard/createDocumentItem",
      resourceString: "myProject/resourceString",
      resStringContentWizard: "contentWizard/resourceString",
      projectAlreadyExistResourceString:
        "myProject/projectAlreadyExistResourceString",
      projectAlreadyExistRString:
        "contentWizard/projectAlreadyExistRString",
      resetContent: "contentWizard/resetContent",
    }),
    async reloadPage() {
      window.location.reload();
    },
    getDisabled() {
      if(this.getLastStep && this.getContentWizardData.isOutOfProject){
        if(this.getContentWizardData.chosenProject.id == null || this.getContentWizardData.chosenProject.id == ''){
          return true;
        }else{
          return false;
        }
      }
      if (
        this.getContentWizardData.contentItem.type ==
        this.CustomContentItemTypes.product
      ) {
        if (this.getContentWizardData.step == 2) {
          if(!this.getContentWizardData.contentItem?.selectedProduct || !this.getisProductSearchDisabled || this.getContentWizardData.productType?.length === 0){
            return true;
          }else{
            return false;
          }
        } else if (
          this.getContentWizardData.step == 3 &&
          !this.getContentWizardData.step3.length > 0
        ) {
          return true;
        } else if (
          this.getContentWizardData.step == 4 &&
          !this.getContentWizardData.contentItem.coverPhoto
        ) {
          return true;
        } else {
          return false;
        }
      } else if (
        this.getContentWizardData.contentItem.type ==
        this.CustomContentItemTypes.virtualTray
      ) {
        if (this.getselectedTrayId == "") {
          return true;
        } else {
          return false;
        }
      } else if (
        this.getContentWizardData.contentItem.type ==
        this.CustomContentItemTypes.galleryImages
      ) {
        if (this.getselectedTrayId == "") {
          return true;
        } else {
          return false;
        }
      } else if (
        this.getContentWizardData.contentItem.type ==
        this.CustomContentItemTypes.addDocument
      ) {
        if (this.getSelectedDocument?.length == 0 || this.getSelectedDocument == null) {
          return true;
        } else {
          return false;
        }
      }
      else if(this.getContentWizardData.contentItem.type == this.CustomContentItemTypes.webPage){
        if(this.getContentWizardData.selectedWebPage?.pageName){
          return false
        }
        return true
      }
      return true
    },

    async addProjectItem() {
      this.disableSubmitButton = true;
      try {
        let sectionId = '';
        if(this.getContentWizardData.chosenProject?.sections)
        {
          sectionId = this.getContentWizardData.chosenProject.sections.find(
            item => item.title == "default"
          );
        }
        else{
          sectionId = this.myProjectDetails?.boardDetails.sections.find(
            item => item.title == "default"
          );
        }


        let data = {
          boardId: this.getContentWizardData.chosenProject.id != '' ? this.getContentWizardData.chosenProject.id : this.getContentWizardData.contentItem?.itemBoardId,
          contentItem: {
            title: this.getContentWizardData.contentItem?.title,
            description: this.getContentWizardData.contentItem?.description,
            coverPhoto: this.getContentWizardData.contentItem?.coverPhoto,
            coverPhotoImageAltText: this.getContentWizardData.contentItem?.coverPhotoImageAltText,
            thumbnailUrl: "",
            link: this.getSelectedProduct?.styleNameURL,
            type: this.getItemType,
            size: this.getContentWizardData.contentItem?.size,
            row: 1,
            column: 1,
            sectionId: sectionId.id,
            isItemSelected: false,
            seoUrl: "",
            collectionCode: "",
            itemBoardId: this.getContentWizardData.contentItem?.itemBoardId != ''? this.getContentWizardData.contentItem?.itemBoardId : this.getContentWizardData.chosenProject.id
          },
          productContentItem: {
            productId: this.getContentWizardData.contentItem?.productId,
            productStyleImages: this.getContentWizardData?.step3,
            savedImages: [],
            productInventoryType: this.getContentWizardData?.contentItem
              ?.productInventoryType,
            productType: this.getContentWizardData.contentItem?.productType
          }
        };

        let dataArray = [];
        this.getSelectedDocument?.forEach(element => {
          let newData = {
            boardId: this.projectDetails?.boardDetails.id,
            contentItem: {
              title: element.title,
              description: this.getContentWizardData.contentItem?.description,
              coverPhoto: element?.icon,
              coverPhotoImageAltText: element?.coverPhotoImageAltText ?? "",
              thumbnailUrl: "",
              link:element?.link,
              type: this.getItemType,
              size: this.getContentWizardData.contentItem?.size,
              row: 1,
              column: 1,
              sectionId: sectionId.id,
              isItemSelected: true,
              seoUrl: "",
              collectionCode: ""
            }
          };
          dataArray.push(newData);
        });

        if(this.getContentWizardData.selectedWebPage.pageName)
        {
          data = {
            boardId: this.projectDetails?.boardDetails.id,
            "contentItem": {
                "title": this.getContentWizardData.selectedWebPage.pageName,
                "description": this.getContentWizardData.contentItem?.description,
                "coverPhoto": this.getContentWizardData.selectedWebPage.pageImageSrc.replace("~", ""),
                "coverPhotoImageAltText": "",
                "link": this.getContentWizardData.selectedWebPage.pageUrl,
                "type": this.getContentWizardData.contentItem?.type,
                "size": this.getContentWizardData.contentItem?.size,
                "row": 0,
                "column": 1,
                "sectionId": sectionId.id,
                "isItemSelected": true
            }
          }
        }

        await this.resourceString(
          this.$resourceString["common.accounts.Created.Msg"]
        );
        await this.resStringContentWizard(
          this.$resourceString["common.accounts.Created.Msg"]
        );
        await this.projectAlreadyExistResourceString(
          this.$resourceString["common.accounts.DuplicateName.Msg"]
        );
        await this.projectAlreadyExistRString(
          this.$resourceString["common.accounts.DuplicateName.Msg"]
        );

        if(dataArray?.length>0){
          await this.createDocumentItem(dataArray).then(resp => {
            if(resp == true){
              this.reloadPage();
              this.hideModal("project-wizard-content");
            }
          });
        }else{
          await this.createProductItem(data).then(resp => {
            if(resp == true && this.getProjectDetails?.boardDetails?.sections?.length>0){
              this.reloadPage();
            }else{
              this.$emit("closeModal");
            }
          });
        }
      } catch (error) {
        // Handle errors if necessary
        console.log(error);
      } finally {
        this.disableSubmitButton = false;
      }
    },
    getStepComp() {
      if (this.getContentWizardData.step === 1) {
        return null;
      }
      const StepComponent = getStepComponent(
        this.getContentWizardData.contentItem.type,
        this.getContentWizardData.step
      );

      return StepComponent;
    },
    getClassName(stepNumber) {
      const num = parseInt(stepNumber, 10);
      return {
        active: this.getContentWizardData.step === num,
        complet: this.getContentWizardData.step > num
      };
    },
    handleNext() {
      this.setStep(this.getContentWizardData.step + 1);
    },
    handleBack() {
      if (
        this.getContentWizardData.step === 2
      ) {
        this.setStep1("brand");
      }
      this.setStep(this.getContentWizardData.step - 1);
      const isCustomPatternType = this.isCustomPattern(
        this.getContentWizardData.contentItem.type
      );
      if (isCustomPatternType) {
        this.setStep1("product");
      }
    },
    hideModal(name) {
      this.$modal.hide(name + "-modal");
      this.resetContent();
    },

    closeModal(){
      this.hideModal('project-wizard-content-modal');
      this.$emit("closeModal");
    },
    isCustomPattern(type) {
      ContentItemTypes.customPattern === type;
    }
  }
};
</script>
